export const POPULATE_SIGNUP_FORM = '@@signupFormData/POPULATE_SIGNUP_FORM';

/**
 * Populate the signup form with data
 * @param {Object} params
 * @param {String} params.email
 * @param {String} params.first_name
 * @param {String} params.last_name
 * @param {String} [params.sign_up_token] - mentor token
 * @param {String} [params.invitation_token] - employee token
 */
export const populateSignupForm = ({
  email,
  firstName,
  lastName,
  sign_up_token,
  invitation_token,
}: SignupFormDataType) => ({
  type: POPULATE_SIGNUP_FORM,
  email,
  firstName,
  lastName,
  sign_up_token,
  invitation_token,
});
